import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useGetAllPendingStatusList } from "src/pages/Configuration/Parameters/Others/PendingStatus/api/getAllPendingStatusList";
import { useGetAllProvidersList } from "src/pages/Configuration/Parameters/Others/Providers/api/getAllProvidersList";
import { useGetAllUsedByList } from "src/pages/Configuration/Parameters/Lines/UsedBy/api/getAllUsedByList";
import { useGetAllLineTypesList } from "src/pages/Configuration/Parameters/Lines/LineTypes/api/getAllLineTypesList";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";
import { useGetPhoneLineBillingViaPhoneNumber } from "./api/getPhoneLineBillingViaPhoneNumber";



const EditPhoneLineForm = ({ initialValues, onSubmit ,unitType, onBillingButtonClick, isBillingModalActive }: EditPhoneLineFormProps) => {
  const { t } = useTranslation();
  const getAllPendingStatusListQuery = useGetAllPendingStatusList();
  const getAllProvidersListQuery = useGetAllProvidersList(); 
  const getAllUsedByListQuery = useGetAllUsedByList(); 
  const getAllLineTypesListQuery = useGetAllLineTypesList();
  const getPhoneLineBillingViaPhoneNumberQuery = useGetPhoneLineBillingViaPhoneNumber({phoneNumber: initialValues.phoneNumber})

   const validationSchema= Yup.object({
    unitID: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    pendingStatusID: Yup.string().test({
      name: "exclusiveFields",
      exclusive: true,
      test: function(value) {
        const { usedByID } = this.parent;
        return !(value && usedByID && value.trim() !== "" && usedByID.trim() !== "");
      },
      message: "Επιλέξτε ένα απο τα δύο πεδία",
    }).test({
      name: "atLeastOneField",
      test: function(value) {
        const { usedByID } = this.parent;
        return value || usedByID;
      },
      message: "Τουλάχιστον ένα από τα πεδία 'Εκκρεμότητα' ή 'Χρήση Απο' πρέπει να επιλεγεί",
    }),
    usedByID: Yup.string().test({
      name: "exclusiveFields",
      exclusive: true,
      test: function(value) {
        const { pendingStatusID } = this.parent;
        return !(value && pendingStatusID && value.trim() !== "" && pendingStatusID.trim() !== "");
      },
      message: "Επιλέξτε ένα απο τα δύο πεδία",
    }).test({
      name: "atLeastOneField",
      test: function(value) {
        const { pendingStatusID } = this.parent;
        return value || pendingStatusID;
      },
      message: "Τουλάχιστον ένα από τα πεδία 'Εκκρεμότητα' ή 'Χρήση Απο' πρέπει να επιλεγεί",
    }),
  }) 

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema} 
    >
      {({ errors, touched, isSubmitting, setFieldValue ,values }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>

            <UnitsSelectionDropdown errors={errors} touched={touched} unitType={unitType} initialUnitID={initialValues.unitID} /> 

              <Col xs={6}>
                <label className="form-label">
                  {t("Αριθμός Αίτησης")}
                </label>
                <Field
                  name="applProtocolNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="applProtocolNumber"
                  
                />
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Αίτησης")}
                </label>
                <Field 
                  name="applDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.applDate && touched.applDate && (
                    <div> {errors.applDate}</div>
                  )}
                </div>               
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Επίσημη Ημερομηνία Αίτησης")}
                </label>
                <Field 
                  name="offApplDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.offApplDate && touched.offApplDate && (
                    <div>{errors.offApplDate}</div>
                  )}
                </div>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Ημερομηνία Παράδοσης")}
                </label>
                <Field 
                  name="deliveryDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.deliveryDate && touched.deliveryDate && (
                    <div>{errors.applDate}</div>
                  )}
                </div>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εκκρεμότητα")}*`}
                </label>
                <Field
                  as="select"
                  name="pendingStatusID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="pendingStatusID"
                >
                <option value="">{t("Επιλέξτε Εκκρεμότητα")}</option>
                {getAllPendingStatusListQuery.data &&
                  getAllPendingStatusListQuery.data.map((pending) => (
                    <option key={pending.id} value={pending.id}>
                      {pending.description}
                    </option>
                  ))}
              </Field>
              <div className="text-danger">
                  {errors.pendingStatusID && touched.pendingStatusID && (
                    <div>{errors.pendingStatusID}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Πάροχος")}`}
                </label>
                <Field
                  as="select"
                  name="providerID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="providerID"
                >
                <option value="0">{t("Επιλέξτε Πάροχο")}</option>
                {getAllProvidersListQuery.data &&
                  getAllProvidersListQuery.data.map((provider) => (
                    <option key={provider.id} value={provider.id}>
                      {provider.description}
                    </option>
                  ))}
              </Field>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Τύπος Γραμμής")}`}
                </label>
                <Field
                  as="select"
                  name="lineTypeID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="lineTypeID"
                >
                <option value="">{t("Επιλέξτε τύπο Γραμμής")}</option>
                {getAllLineTypesListQuery.data &&
                  getAllLineTypesListQuery.data.map((lineType) => (
                    <option key={lineType.id} value={lineType.id}>
                      {lineType.description}
                    </option>
                  ))}
              </Field>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Χρήση Απο")}*`}
                </label>
                <Field
                  as="select"
                  name="usedByID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="usedByID"
                >
                <option value="">{t("Επιλέξτε Χρήση από")}</option>
                {getAllUsedByListQuery.data &&
                  getAllUsedByListQuery.data.map((usedby) => (
                    <option key={usedby.id} value={usedby.id}>
                      {usedby.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.usedByID && touched.usedByID && (
                    <div>{errors.usedByID}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Περιγραφή Γραμμής")}`}
                </label>
                <Field
                  name="descline"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="descline"
                 
                />
                <div className="text-danger">
                  {errors.descline && touched.descline && (
                    <div>{errors.descline}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Ημερομηνία Κατάργησης")}
                </label>
                <Field 
                  name="removalDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.removalDate && touched.removalDate && (
                    <div>{errors.removalDate}</div>
                  )}
                </div>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Πάγιο")}
                </label>
                <Field
                  name="cost"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="cost"
                  disabled
                />
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Εμπορική")}
                </label>
                <Field
                  type="checkbox"
                  name="isEmporiki"
                  field="isEmporiki"
                  className="mt-3 mb-3"
                />
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Citibank")}`}
                </label>
                <Field
                  type="checkbox"
                  name="isCiti"
                  field="isCiti"
                  className="mt-3 mb-3"
                />
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Κωδικός SAP")}
                </label>
                <Field
                  type="text"
                  name="sapCode"
                  field="sapCode"
                  className="form-control"
                />
              </Col>

              <Col xs={6} >
                <label className="form-label">
                  {t("Αριθμός Κλήσης")}
                </label>
                <div style={{ display: 'flex', alignItems: 'center' }}> 
                  <Field
                    type="text"
                    name="phoneNumber"
                    field="phoneNumber"
                    className="form-control"
                  />
                  <Button
                    type="button"
                    size="sm"
                    styletype="primary"
                    onClick={onBillingButtonClick}
                    className="py-2 px-2 w-25"
                    disabled={isBillingModalActive}
                  >
                    {t("Χρεώσεις")}
                    {isBillingModalActive && <Spinner size="sm" className="ms-1"/>}
                  </Button>
                </div>
              </Col>

              <Col xs={6} style={{ marginTop: '15px', marginBottom: '15px' }}>
                <label className="form-label">
                  {t("Τύπος απο Πάροχο:")}
                </label>
                <div>
                  {getPhoneLineBillingViaPhoneNumberQuery.data &&
                    getPhoneLineBillingViaPhoneNumberQuery.data.map((item, index) => (
                      <div key={index}>
                        {`${index + 1}) ${item.oteConType ? item.oteConType : "-"}`}
                      </div>
                    ))}
                </div>
              </Col>

              <Col xs={6} style={{ marginTop: '15px', marginBottom: '15px' }}>
                <label className="form-label">
                  {t("Διεύθυνση απο Πάροχο:")}
                </label>
                <div>
                  {getPhoneLineBillingViaPhoneNumberQuery.data &&
                    getPhoneLineBillingViaPhoneNumberQuery.data.map((item, index) => (
                      <div key={index}>
                        {`${index + 1}) ${item.address ? item.address : '-'}`}
                      </div>
                    ))}
                </div>
              </Col>

              <Col xs={12}>
                <label className="form-label">
                  {t("Σχόλια")}
                </label>
                <Field
                  type="text"
                  name="comments"
                  field="comments"
                  className="form-control"
                  as="textarea"
                />
              </Col>
          
            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {t("Αποθήκευση")}
            </Button>
          </div>
        </Form>
    )}
    </Formik>
)
}

export default EditPhoneLineForm;

type EditPhoneLineFormProps = {
  initialValues: IEditPhoneLineForm;
  unitType:string | undefined;
  onSubmit: (
    values: IEditPhoneLineForm,
    formikHelpers: FormikHelpers<IEditPhoneLineForm>
  ) => void;
  onBillingButtonClick: () => void;
  isBillingModalActive: boolean;
};

